import { render, staticRenderFns } from "./ProgressCircle.vue?vue&type=template&id=88154420&scoped=true&"
import script from "./ProgressCircle.vue?vue&type=script&lang=ts&"
export * from "./ProgressCircle.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressCircle.vue?vue&type=style&index=0&id=88154420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88154420",
  null
  
)

export default component.exports